/* eslint-disable camelcase */
import { faCompass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { toHHMM } from '../../../utils/formatTime';
import { getProgramTypeBadgeClass } from '../../../utils/minside/activities';

function OverviewActivityCard({ aktivitet }) {
    return (
        <article className="overview-activity-card">
            <div className="overview-activity-card__top">
                <span className="overview-activity-card__time">
                    {toHHMM(aktivitet.fratid)}–{toHHMM(aktivitet.tiltid)}
                </span>

                {aktivitet.type_navn && (
                    <span
                        className={`program-type-badge ${getProgramTypeBadgeClass(
                            aktivitet.type_navn
                        )}`}
                    >
                        {aktivitet.type_navn}
                    </span>
                )}
            </div>

            <h4 className="overview-activity-card__title">{aktivitet.tittel}</h4>

            {aktivitet.sted && (
                <div className="overview-activity-card__location">
                    <FontAwesomeIcon icon={faCompass} />
                    {aktivitet.sted}
                </div>
            )}
        </article>
    );
}

export default OverviewActivityCard;
